import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faFileArrowDown, faXmark } from "@fortawesome/free-solid-svg-icons";
import UtcToLocal from "../UtcToLocal";
import AppButton from "../Common/Button";
import { normalizeCurrencyCode } from "../../../features/ValueFormater";
import "../../Styles/components/statement-export-modal.scss";

const dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
};

export default function StatementExportModal({
  isOpen,
  onClose,
  currencyId,
  dateFrom,
  dateTo,
  onConfirm,
}) {
  const [step, setStep] = useState(1);
  const [fileType, setFileType] = useState("non-official");

  useEffect(() => {
    if (!isOpen) {
      setStep(1);
      setFileType("non-official");
    }
  }, [isOpen]);

  return (
    <Modal
      centered
      show={isOpen}
      onHide={onClose}
      dialogClassName="statement-export-modal-wrapper"
    >
      <Modal.Body className="statement-export-modal">
        <button
          type="button"
          className="statement-export-modal__close"
          onClick={onClose}
          aria-label="Close export dialog"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <div className="statement-export-modal__progress" aria-hidden="true">
          <span className={step === 1 ? "is-active" : ""} />
          <span className={step === 2 ? "is-active" : ""} />
        </div>

        {step === 1 ? (
          <>
            <header className="statement-export-modal__header">
              <span className="statement-export-modal__icon">
                <FontAwesomeIcon icon={faFileArrowDown} />
              </span>
              <div>
                <h3>Export Statement of Account</h3>
                <p>Choose the statement format before proceeding to authorization.</p>
              </div>
            </header>

            <section className="statement-export-modal__section">
              <h4>Timeframe</h4>
              <div className="statement-export-modal__date-grid">
                <div className="statement-export-modal__date-card">
                  <span>From</span>
                  <strong>
                    <UtcToLocal utcTimestamp={dateFrom} options={dateOptions} />
                  </strong>
                </div>
                <div className="statement-export-modal__date-card">
                  <span>To</span>
                  <strong>
                    <UtcToLocal utcTimestamp={dateTo} options={dateOptions} />
                  </strong>
                </div>
              </div>
            </section>

            <section className="statement-export-modal__section">
              <h4>File type</h4>
              <div className="statement-export-modal__choices">
                <label
                  className={`statement-export-modal__choice ${
                    fileType === "non-official" ? "is-active" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="soa-file-type"
                    value="non-official"
                    checked={fileType === "non-official"}
                    onChange={(event) => setFileType(event.target.value)}
                  />
                  <span>.pdf | Non-Official Document</span>
                </label>

                <label
                  className={`statement-export-modal__choice ${
                    fileType === "official" ? "is-active" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="soa-file-type"
                    value="official"
                    checked={fileType === "official"}
                    onChange={(event) => setFileType(event.target.value)}
                  />
                  <span>
                    .pdf | Signed Official Document
                    <small>Delivered in 3 days and $10 fees apply</small>
                  </span>
                </label>
              </div>
            </section>

            <div className="statement-export-modal__actions">
              <AppButton
                type="button"
                variant="primary"
                onClick={() => setStep(2)}
              >
                Confirm Export
              </AppButton>
            </div>
          </>
        ) : (
          <>
            <header className="statement-export-modal__header is-confirmation">
              <span className="statement-export-modal__icon is-success">
                <FontAwesomeIcon icon={faCheck} />
              </span>
              <div>
                <h3>Statement of Account Confirmation</h3>
                <p>The statement of account will be automatically downloaded.</p>
              </div>
            </header>

            <div className="statement-export-modal__summary">
              <div>
                <span>Statement Currency</span>
                <strong>{normalizeCurrencyCode(currencyId)}</strong>
              </div>
              <div>
                <span>Date Range</span>
                <strong>
                  <UtcToLocal utcTimestamp={dateFrom} options={dateOptions} /> -{" "}
                  <UtcToLocal utcTimestamp={dateTo} options={dateOptions} />
                </strong>
              </div>
              {fileType === "official" ? (
                <div>
                  <span>Fees</span>
                  <strong>$10</strong>
                </div>
              ) : null}
            </div>

            <div className="statement-export-modal__actions">
              <AppButton
                type="button"
                variant="primary"
                onClick={() => onConfirm?.(fileType)}
              >
                Download
              </AppButton>
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
